// MultiPathRoute.jsx
import PropTypes from 'prop-types';
import React from 'react';
import { Route, Routes } from 'react-router';

export const MultiPathRoute = ({ paths, element }) => {
  if (!paths.length) return null;
  return (
    <Routes>
      {paths.map(path => (
        <Route key={path} path={path} element={element} />
      ))}
      {/* To prevent react-router "no routes matched location" warning */}
      <Route path="*" element={null} />
    </Routes>
  );
};

MultiPathRoute.propTypes = {
  paths: PropTypes.array.isRequired,
  element: PropTypes.element.isRequired,
};

MultiPathRoute.defaultProps = {
  paths: [],
};

export default MultiPathRoute;
